/* ============================================================
   Cleanly Bundle Selector — selection + add to cart
   Works for any [data-cl-bundle] root. Config is in a
   <script type="application/json" data-bundle-config> child.

   Sold out: each offer may carry "available": false (set in Liquid from
   the real product availability). Then the CTA reads אזל מהמלאי and is
   disabled. If an add still fails at runtime (stock ran out between page
   load and click) the button says so inline — never a blocking alert().
   ============================================================ */
(function () {
  var SOLD_OUT = 'אזל מהמלאי';
  var GENERIC_ERR = 'אירעה שגיאה, נסו שוב';

  function fmt(n) {
    return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function keepHtml(btn) {
    if (btn.__clHTML == null) btn.__clHTML = btn.innerHTML;
    return btn.__clHTML;
  }

  /* Swap the button label for a short message, then put it back. */
  function flash(btn, msg) {
    keepHtml(btn);
    if (btn.__clTimer) clearTimeout(btn.__clTimer);
    btn.innerHTML = '<span class="clb2__ctatext">' + msg + '</span>';
    btn.classList.add('is-soldout');
    btn.__clTimer = setTimeout(function () {
      btn.innerHTML = btn.__clHTML;
      btn.classList.remove('is-soldout');
      btn.__clTimer = null;
      if (btn.__clRepaint) btn.__clRepaint();
    }, 4000);
  }

  function hideNativeButtons(root) {
    // Our bundle is rendered inside the add-to-cart block, which sits in
    // .product-form-buttons next to quantity + accelerated-checkout. Hide
    // those siblings so the bundle CTA is the single purchase path — but
    // never hide the element that contains our bundle.
    var pfb = root.closest('.product-form-buttons');
    if (pfb) {
      [].slice.call(pfb.children).forEach(function (ch) {
        if (!ch.contains(root)) ch.style.display = 'none';
      });
    }
  }

  function initBundle(root) {
    if (root.__clInit) return;
    root.__clInit = true;

    var cfg = { offers: [], key: '' };
    var cfgEl = root.querySelector('[data-bundle-config]');
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var offers = cfg.offers || [];
    if (!offers.length) return;

    var def = parseInt(root.getAttribute('data-default') || '1', 10);
    var selected = Math.min(Math.max(def - 1, 0), offers.length - 1);

    function isAvailable(offer) {
      return !offer || offer.available !== false;
    }

    function render() {
      root.querySelectorAll('[data-opt]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-opt'), 10);
        el.classList.toggle('is-selected', i === selected);
        el.classList.toggle('is-soldout', !isAvailable(offers[i]));
      });

      var offer = offers[selected];
      var ok = isAvailable(offer);

      root.querySelectorAll('[data-cl-cta]').forEach(function (btn) {
        keepHtml(btn);
        btn.__clRepaint = paintPrice;
        if (btn.__clTimer) return; // a flash message is showing, leave it
        if (!ok) {
          btn.innerHTML = '<span class="clb2__ctatext">' + SOLD_OUT + '</span>';
          btn.classList.add('is-soldout');
          btn.setAttribute('disabled', '');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          if (btn.classList.contains('is-soldout')) btn.innerHTML = btn.__clHTML;
          btn.classList.remove('is-soldout');
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        }
      });

      paintPrice();

      // Per-option detail panels: show an element only when its option is
      // selected. data-show-opt="2" (single) or "0,2" (multiple). Elements
      // without the attribute are untouched (other bundles unaffected).
      root.querySelectorAll('[data-show-opt]').forEach(function (el) {
        var want = el.getAttribute('data-show-opt').split(',').map(function (s) { return parseInt(s, 10); });
        el.style.display = (want.indexOf(selected) !== -1) ? '' : 'none';
      });
    }

    function paintPrice() {
      var price = offers[selected] ? offers[selected].price : 0;
      root.querySelectorAll('[data-cta-price]').forEach(function (el) { el.textContent = fmt(price); });
    }

    root.querySelectorAll('[data-opt]').forEach(function (el) {
      el.addEventListener('click', function () {
        selected = parseInt(el.getAttribute('data-opt'), 10);
        render();
      });
    });

    function props(isGift, freeShip) {
      var p = { '_bundle': (cfg.key || 'bundle') + '-offer' + (selected + 1) };
      if (freeShip) p['_ships_free'] = 'true';
      if (isGift) {
        p['מתנה'] = '✓';
        p['_gift'] = 'true';
        // What the gift depends on. If these main items are later removed
        // from the cart the gift stops being a gift (see cl-cart-gifts.js).
        p['_req'] = (offers[selected].items || []).map(function (it) {
          return it.id + 'x' + (it.qty || 1);
        }).join(',');
      }
      return p;
    }

    root.querySelectorAll('[data-cl-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var offer = offers[selected];
        if (!offer || btn.getAttribute('aria-busy') === 'true') return;
        if (!isAvailable(offer)) { flash(btn, SOLD_OUT); return; }
        btn.setAttribute('aria-busy', 'true');

        // Look at the cart first: if a gift from this offer is already there
        // (e.g. the shopper is buying a second bundle that includes the same
        // microfiber pack) do not add a duplicate. Two identical gift lines
        // would make the two bundle discounts compete for the same product
        // and one of them would end up charged.
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var have = {};
            ((cart && cart.items) || []).forEach(function (i) { have[i.variant_id] = true; });

            var items = [];
            var freeShip = !!offer.freeShipping;
            (offer.items || []).forEach(function (it) {
              items.push({ id: Number(it.id), quantity: it.qty || 1, properties: props(false, freeShip) });
            });
            (offer.gifts || []).forEach(function (it) {
              if (have[Number(it.id)]) return;
              items.push({ id: Number(it.id), quantity: it.qty || 1, properties: props(true, freeShip) });
            });

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          .then(function (r) {
            if (r.ok) return r.json();
            return r.json().catch(function () { return {}; }).then(function (body) {
              var err = new Error('add failed');
              // 422 from /cart/add.js is Shopify saying the item is unavailable.
              err.soldOut = r.status === 422;
              throw err;
            });
          })
          .then(function () {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .catch(function () { return null; });
          })
          .then(function (cart) {
            // Tell the theme the cart changed (Horizon: cart-items-component
            // re-renders itself; cart-drawer announces) and open the side drawer.
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'cl-bundle', data: { source: 'cl-bundle', itemCount: cart && cart.item_count } }
            }));
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            btn.removeAttribute('aria-busy');
          })
          .catch(function (err) {
            btn.removeAttribute('aria-busy');
            flash(btn, (err && err.soldOut) ? SOLD_OUT : GENERIC_ERR);
          });
      });
    });

    hideNativeButtons(root);
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-cl-bundle]').forEach(initBundle);
  }

  // Reset any stuck "busy" CTA when returning to the page (browser Back /
  // bfcache restore) so the add-to-cart button is always clickable again.
  function resetBusy() {
    document.querySelectorAll('[data-cl-cta][aria-busy="true"]').forEach(function (b) {
      b.removeAttribute('aria-busy');
    });
  }
  window.addEventListener('pageshow', resetBusy);
  window.addEventListener('focus', resetBusy);

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
